import validate from "/builds/aschehoug/aschehoug-utdanning/shop-app/node_modules/.pnpm/nuxt@4.4.2_@azure+identity@4.13.0_@babel+core@7.29.0_@babel+plugin-syntax-jsx@7.28.6_@b_9fbdec1ae8d1fe380d7267799a951312/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/builds/aschehoug/aschehoug-utdanning/shop-app/app/middleware/auth.global.ts";
import manifest_45route_45rule from "/builds/aschehoug/aschehoug-utdanning/shop-app/node_modules/.pnpm/nuxt@4.4.2_@azure+identity@4.13.0_@babel+core@7.29.0_@babel+plugin-syntax-jsx@7.28.6_@b_9fbdec1ae8d1fe380d7267799a951312/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "check-auth": () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/middleware/check-auth.ts"),
  "migrate-product-formats": () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/middleware/migrate-product-formats.ts")
}